import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'axios';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getCurrentCompany, getStyle } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBModal from '../../shared/CBModal';
import { getLengthValidator } from '../../../utils/validators';
import { toast } from 'react-toastify';

class RequestServiceEntryModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        registrationNumber: '',
      },
      formValid: {
        registrationNumber: false,
      },
    };
  }

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    const newFormValid = {
      ...formValid,
      [name]: isValid,
    };

    this.setState({ formValid: newFormValid });
  };

  getIsValid = () => {
    const { formValid } = this.state;
    let isValid = true;
    Object.values(formValid).forEach(fieldIsValid => {
      if (!fieldIsValid) {
        isValid = false;
      }
    });
    return isValid;
  };

  updateFormState = changedObject => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData[changedObject.target] = changedObject.value;
    this.setState({ formData: newFormData });
  };

  submitForm = () => {
    const { formData } = this.state;
    const { closeModal, selectedWorkshopId, setSelectedEntry } = this.props;

    // Make the API call to request service history
    axios.post('/api/1/integrations/oe/initialize-dsb-entry-without-maintenance/', {
      registration_number: formData.registrationNumber,
      workshop_id: selectedWorkshopId,
    })
      .then(response => {
        const entry = response.data;
        if (entry.status === 'available') {
          setSelectedEntry(response.data);
        } else {
          toast.error("Ajoneuvolle ei ole saatavilla valmistajan huoltokirjaa");
        }
        closeModal();
      })
      .catch(error => {

        if (error.response) {
          toast.error(error.response.data.error);
        }
      });
  };

  render() {
    const { formData } = this.state;
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      selectedWorkshopId,
      t,
      user
    } = this.props;

    const isTrialingOE = getCurrentCompany(user, null, selectedWorkshopId, null).is_trialing_oe;

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            contentLabel='Request service history modal'
            isValid={this.getIsValid()}
            submitForm={this.submitForm}
            submitText={t('request', { ns: 'common' })}
            cancelText={t('cancel', { ns: 'common' })}
            title={t('enterServiceHistory', { ns: 'ManufacturerServiceBook' })}
            descriptionText={t('requestServiceEntryDescription', { ns: 'ManufacturerServiceBook' })}
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                <CBInputField
                  name='registrationNumber'
                  inputStyle={getStyle(screenSize, styles, 'input')}
                  value={formData.registrationNumber}
                  placeholder={t('enterRegistrationNumber', { ns: 'common' })}
                  onChange={this.updateFormState}
                  validators={[getLengthValidator(1, 20)]}
                  isValidCallback={this.setIsValid}
                  labelText={t('registrationNumber', { ns: 'common' })}
                  labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                />
              </div>
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 32px 16px 32px'
    },
    formComponentContainer: {
      marginBottom: 16,
    },
    inputLabelText: {
      color: 'black',
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px'
    }
  },
};

function mapStateToProps(state) {
  return {
    selectedChainId: state.chain.selectedChainId,
  };
}

export default connect(mapStateToProps)(translate()(RequestServiceEntryModal));